import { Spinner } from '@shared/components/ui/Spinner';

interface LoadingStateProps {
  message?: string;
  className?: string;
}

/**
 * Componente LoadingState - Muestra un estado de carga con spinner animado
 */
export const LoadingState = ({ className = 'min-h-[calc(100vh-150px)]' }: LoadingStateProps) => {
  return (
    <div className={`flex flex-col items-center justify-center w-full ${className}`}>
      <Spinner size="md" />
    </div>
  );
};
